import React from 'react';
import 'styled-components/macro';
import { NewTabs, NewTab, NewTabList, NewTabPanel, styles } from '@grownode/ui';

export function Tabs({ config, selectedId, onTabClick }) {
  return (
    <NewTabs selectedId={selectedId}>
      <NewTabList aria-label="My tabs">
        {config.map((tab, key) => {
          const tabClick =
            typeof onTabClick === 'function' ? onTabClick : () => {};
          return (
            <NewTab
              key={key}
              id={tab.id}
              onClick={() => tabClick(tab.id)}
              css={`
                height: 95px;
                line-height: 20px;
                padding: 8px;
                width: 25%;
              `}
            >
              {tab.title}
            </NewTab>
          );
        })}
      </NewTabList>
      {config.map((tab, key) => {
        return (
          <NewTabPanel
            key={key}
            css={`
              padding: 16px;
              background-color: ${styles.colors.plain};
              border-left: 1px solid ${styles.colors.grayRegular};
              border-right: 1px solid ${styles.colors.grayRegular};
              border-bottom: 1px solid
                ${styles.colors.grayRegular};
            `}
          >
            {tab.content}
          </NewTabPanel>
        );
      })}
    </NewTabs>
  );
};

export default Tabs;
